import { ErrorModal } from "@dexteel/mesf-core";
import { useState } from "react";
import { useLocation, useParams } from "react-router-dom";
import {
  useRecipesQuery,
  useInvalidateRecipes,
} from "@/pages/sy/hooks/queries/useRecipesQuery";
import { TableRecipe } from "../components/TableRecipe";

export const RecipePage = () => {
  const { recipeId } = useParams();
  const [error, setError] = useState("");
  const location = useLocation();
  const [viewMode, setViewMode] = useState<"read" | "edit">("read");

  const basePath = location.pathname.startsWith("/scrap-recipes")
    ? "/scrap-recipes"
    : "/configuration/recipes";

  const { data: recipes = [], isLoading } = useRecipesQuery(
    false,
    false,
    (err) => setError(err.message),
  );
  const invalidateRecipes = useInvalidateRecipes();

  return (
    <>
      <TableRecipe
        recipeId={recipeId}
        isLoading={isLoading}
        recipes={recipes}
        invalidateRecipes={invalidateRecipes}
        basePath={basePath}
        viewMode={viewMode}
        setViewMode={setViewMode}
      />
      <ErrorModal error={error} onHide={() => setError("")} />
    </>
  );
};
